import { render } from "./Criterion.vue?vue&type=template&id=c4729d10&scoped=true"
import script from "./Criterion.vue?vue&type=script&lang=js"
export * from "./Criterion.vue?vue&type=script&lang=js"

import "./Criterion.vue?vue&type=style&index=0&id=c4729d10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4729d10"]])

export default __exports__